import { Box, Typography } from '@mui/material';
import NavGroup from 'layout/drawer/content/navigation/NavGroup.tsx';
import menuItems from 'navigation/menuItems.ts';
import projectMenuItems from 'navigation/projectMenuItems.ts';
import { useParams } from 'react-router';
import { useStore } from 'store/store.ts';
import { useNavigation } from './useNavigation';
import { NavigationButton } from './NavigationButtons';

const Navigation = () => {
  const { projectId } = useParams();
  const { buttonConfig, shouldShowNavItems } = useNavigation();
  const isDrawerOpen = useStore().drawerOpen;

  const prefixedProjectMenuItems = projectMenuItems.items.map((item) => {
    if (item.children) {
      return {
        ...item,
        children: item.children.map((child) => ({
          ...child,
          url: `/projects/${projectId}${child.url}`,
        })),
      };
    }
    return item;
  });

  const items = projectId ? prefixedProjectMenuItems : menuItems.items;
  const navGroups = items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return (
    <div>
      <div className={isDrawerOpen ? 'mx-2 overflow-hidden mt-2' : 'px-6 flex justify-center mt-3'}>
        <NavigationButton isDrawerOpen={isDrawerOpen} buttonConfig={buttonConfig} />
      </div>
      {shouldShowNavItems && <Box sx={{ pt: 2 }}>{navGroups}</Box>}
    </div>
  );
};

export default Navigation;
